import { ActionIcon, Group, Text, TextProps, Tooltip } from '@mantine/core';
import { useClipboard } from '@mantine/hooks';
import { PiCheck, PiCopy } from 'react-icons/pi';

export default function CopyInput({
  value,
  label,
  ...props
}: TextProps & { value: string; label?: string }) {
  const { copied, copy } = useClipboard({ timeout: 2000 });

  props.size = props.size || 'xs';
  props.c = props.c || 'dimmed';

  return (
    <Tooltip label={copied ? 'Copied' : 'Copy'} withArrow>
      <Group
        onClick={() => copy(value)}
        gap={0}
        style={{ cursor: 'pointer', pointerEvents: 'all', userSelect: 'none' }}
      >
        <Text {...props}>{label ? `${label}: ${value}` : value}</Text>
        <ActionIcon color={copied ? 'teal' : 'gray'} variant="transparent">
          {copied ? <PiCheck size={12} /> : <PiCopy size={12} />}
        </ActionIcon>
      </Group>
    </Tooltip>
  );
}
